module.exports = __webpack_public_path__ + "img/slide12.c1a392ea.png";